import DigitalAccountMenu from "@/components/SideMenus/DigitalAccountMenu";
import NavigationLayout from "@/components/NavigationLayout";
import { DashboardRoutes, dashboardRoutesArray } from "@/router/constant";
import { DetectMobileView } from "@/router/DetectMobileView";
import { useMemo } from "react";
import { useAsync } from "react-use";
import { useAppDispatch } from "@/utils";
import { getBankAccounts, getBankAgreements } from "@payping/redux/actions";
import { Outlet, useLocation } from "react-router-dom";

const MobileDigitalAccountWrapper = () => {
  const location = useLocation();
  const memoDashboardRoutesArray = useMemo(() => dashboardRoutesArray(), []);
  const currentUrlObj = memoDashboardRoutesArray.find((i) => i.url === location.pathname);

  const mainMenu = <DigitalAccountMenu />;

  const subMenus = (
    <NavigationLayout
      menu={mainMenu}
      mobileBackNavigation={DashboardRoutes.digitalAccount.root.url}
      mobileTitle={currentUrlObj?.meta.translation || ""}
    >
      <Outlet />
    </NavigationLayout>
  );

  return location.pathname === DashboardRoutes.digitalAccount.root.url ? mainMenu : subMenus;
};

const DesktopDigitalAccountWrapper = () => (
  <NavigationLayout menu={<DigitalAccountMenu />}>
    <Outlet />
  </NavigationLayout>
);

const DigitalAccountRoot = () => {
  const dispatch = useAppDispatch();
  useAsync(async () => {
    await dispatch(getBankAgreements());
  }, [dispatch]);

  useAsync(async () => {
    await dispatch(getBankAccounts());
  }, [dispatch]);

  return <DetectMobileView mobile={<MobileDigitalAccountWrapper />} desktop={<DesktopDigitalAccountWrapper />} />;
};

export default DigitalAccountRoot;
